import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTwitter, faFacebookF, faInstagram, faLinkedinIn, faYoutube } from "@fortawesome/free-brands-svg-icons";
import styled from "styled-components";

// Styled social links container
const SocialLinksContainer = styled.div`
  display: flex;
  gap: 10px;

  a {
    font-size: 18px;
    color: #ffffff;
    background: rgb(38, 132, 240);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    transition: all 0.3s ease-in-out;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);

    &:hover {
      background: rgb(88, 153, 244);
      transform: scale(1.1);
      box-shadow: 3px 3px 12px rgba(0, 0, 0, 0.3);
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
    margin-bottom: 10px;
  }

  @media (max-width: 480px) {
    gap: 8px;

    a {
      width: 35px;
      height: 35px;
      font-size: 16px;
    }
  }
`;

// Map for font-awesome icons
const iconMap = {
  Twitter: faTwitter,
  Facebook: faFacebookF,
  Instagram: faInstagram,
  LinkedIn: faLinkedinIn,
  YouTube: faYoutube,
};

// Functional Component
const SocialLinks = () => {
  const [socialLinks, setSocialLinks] = useState([]);

  useEffect(() => {
    fetch("https://pristineacademicconsultancy.com/Admin/get_social_links.php") // Ensure API URL is correct
      .then((response) => response.json())
      .then((data) => {
        // Filter out invalid links (null, empty, or missing from iconMap)
        const filteredLinks = data.filter(
          (link) => link.social_url && link.social_url.trim() !== "" && iconMap[link.social_name]
        );
        setSocialLinks(filteredLinks);
      })
      .catch((error) => console.error("Error fetching social links:", error));
  }, []);

  return (
    <SocialLinksContainer>
      {socialLinks.map((link) => (
        <a key={link.social_name} href={link.social_url} target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={iconMap[link.social_name]} />
        </a>
      ))}
    </SocialLinksContainer>
  );
};

export default SocialLinks;
